import React from 'react';
import { useButtonClasses } from './useButtonClasses';
import { useTheme } from '../../../theme';
import { join } from '../../../utils';
import { Text } from '../../Typography';
import { Loader } from '../../Loader';
import { Flex } from '../../Layout';
/**
 * `Button` allows user to perform an action. It has multiple variants for various needs.
 * `Button` composes [html button tag](https://www.w3schools.com/tags/tag_button.asp).
 *
 * @see https://fe-docs.int.getresponse.com/gr-ui-neo/index.html?path=/docs/forms-button--page
 */
export const Button = React.forwardRef(({ children, variant = 'primary', size = 'medium', isDisabled, onClick, className, isLoading, tag = 'button', icon, ...props }, ref) => {
    const theme = useTheme();
    const classes = useButtonClasses({
        variant,
        size,
        isDisabled,
        theme,
    });
    const buttonSize = theme.components.button.sizes[size];
    const finalIcon = isLoading ? React.createElement(Loader, { "aria-hidden": true, size: buttonSize.lineHeight }) : icon;
    const isGhostVariant = variant === 'ghost';
    return (React.createElement(Flex, { tag: tag, disabled: isDisabled, ref: ref, maxWidth: isGhostVariant ? 'min-content' : '100%', minWidth: isGhostVariant ? 'min-content' : '80px', alignItems: "center", justifyContent: "center", paddingX: isGhostVariant ? undefined : 'sm', className: join(className, classes.button), onClick: onClick, inline: true, margin: 0, marginX: isGhostVariant ? 'md' : undefined, boxShadow: isGhostVariant ? 'none' : 'card', ...props },
        React.createElement(Text, { tag: "span", fontSize: buttonSize.fontSize, fontWeight: buttonSize.fontWeight, lineHeight: buttonSize.lineHeight, letterSpacing: buttonSize.letterSpacing, marginRight: finalIcon ? 'xs' : undefined, isTruncated: true }, children),
        finalIcon ? finalIcon : null));
});
